export default __webpack_public_path__ + "173356c4c789818ed21fc0d8cec4a84d.png";